module.exports = __webpack_public_path__ + "static/media/nicerballs.13c6e6a6.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/nicerballs.JPG
// module id = 566
// module chunks = 0